import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('INSTITUTIONS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class InstitutionsService extends ApiBaseService<any>{

  constructor() {
    // Recurso del catálogo de Instituciones (IMSS, ISSSTE, privadas, etc.)
    super('institutions');
    log.debug('Servicio de Instituciones inicializado');
  }

}
